import { img2 } from "../../_components/Imagepath";

export default {
    Data: [
        {
          id: 1,
          key:1,
          Invoice: "#4987",
          Category: "Food",
          Created : "23 Mar 2023",
          Name: "John Smith",
          email: "john@example.com",
          img:img2,
          Total: "$1,54,220",
          Paid: "$1,50,000",
          Payment: "Cash",
          Balance: "$0",
          Due: "-",
          Status: "Partially Paid",
          Action: ""
        },
    ]
}